module.exports = __webpack_public_path__ + "img/Anya_O_10.6ea1187b.jpg";